import { render, staticRenderFns } from "./RemoteConsultationTableCmp7.vue?vue&type=template&id=33cb2cff&"
import script from "./RemoteConsultationTableCmp7.vue?vue&type=script&lang=js&"
export * from "./RemoteConsultationTableCmp7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports